<template>
  <div class="vx-row ml-0">
    <div class="vx-col p-8 vx-card">
      <div class="vx-row ml-4"><span class="title_card">{{$t('generalSettingMenu.btn6')}}</span></div>
      <div class="mt-2">
        <div><span class="font-semibold mt-4" style="font-size: 16px">{{$t('generalSettingMenu.isCurrentDevice')}}</span></div>
        <div v-for="item in deviceInfo.filter(el=>el.isCurrentDevice == true)" class="mt-4 p-4 vx-row">
          <div class="md:w-9/12 vx-col">
            <div class="vx-row">
              <div class="mt-1">
              <feather-icon icon="MonitorIcon" class="icon-style"></feather-icon>
              </div>
              <div class="vx-col">
                <div class="vx-row ml-0">
                  <span class="font-semibold">{{item.deviceName}}</span>
                  <div class="ml-2" v-if="(item.city == null)&&(item.region == null)">
                    <span class="ml-2 font-semibold">{{$t('generalSettingMenu.Unknown')}}</span>
                  </div>
                  <div class="ml-2" v-else>
                    <span v-if="item.city" class="ml-2 font-semibold">{{item.city}}</span>
                    <span v-if="item.city == null" class="ml-2 font-semibold">{{$t('generalSettingMenu.Unknown')}}</span>
                    <span v-if="item.region" class="ml-2 font-semibold">{{item.region}}</span>
                    <span v-if="item.region == null" class="ml-2 font-semibold">{{$t('generalSettingMenu.Unknown')}}</span>
                  </div>
                </div>
                <div class="vx-row ml-0">
                  <div>
                    <span class="opacity-50">{{item.deviceConnector}}</span>
                  </div>
                  <div class="ml-2">
                    <span v-if="item.time == null" class="opacity-50">{{$t('generalSettingMenu.Unknown')}}</span>
                    <span v-if="item.time <2 && item.time != null" class="opacity-50">{{$t('generalSettingMenu.justNow')}}</span>
                    <span v-if="item.time <60 && item.time >= 2" class="opacity-50">{{item.time}} {{$t('generalSettingMenu.minuteAgo')}}</span>
                    <span v-if="item.time >=60 && item.time <1440" class="opacity-50">{{parseInt(item.time/60)}} {{$t('generalSettingMenu.hoursAgo')}}</span>
                    <span v-if="item.time>=1440" class="opacity-50">{{parseInt(item.time/1440)}} {{$t('generalSettingMenu.daysAgo')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-3/12 btnLogOut">
            <vs-button @click="confirmLogoutSubAcc(item)" color="danger" style="height: 37px;min-width: 137px;">{{$t('generalSettingMenu.btn6')}}</vs-button>
          </div>
        </div>
        <hr class="opacity-50">
        <div class="mt-4"><span class="font-semibold " style="font-size: 16px">{{$t('generalSettingMenu.addressLogIn')}}</span></div>
        <div v-for="item in deviceInfo.filter(el=>el.isCurrentDevice != true)" class="mt-4 p-4 vx-row">
          <div class="md:w-9/12 vx-col">
            <div class="vx-row">
              <div class="mt-1">
                <feather-icon icon="MonitorIcon" class="icon-style"></feather-icon>
              </div>
              <div class="vx-col">
                <div class="vx-row ml-0">
                  <span class="font-semibold">{{item.deviceName}}</span>
                  <div class="ml-2" v-if="(item.city == null)&&(item.region == null)">
                    <span class="ml-2 font-semibold">{{$t('generalSettingMenu.Unknown')}}</span>
                  </div>
                  <div class="ml-2" v-else>
                    <span v-if="item.city" class="ml-2 font-semibold">{{item.city}}</span>
                    <span v-if="item.city == null" class="ml-2 font-semibold">{{$t('generalSettingMenu.Unknown')}}</span>
                    <span v-if="item.region" class="ml-2 font-semibold">{{item.region}}</span>
                    <span v-if="item.region == null" class="ml-2 font-semibold">{{$t('generalSettingMenu.Unknown')}}</span>
                  </div>
                </div>
                <div class="vx-row ml-0">
                  <div>
                    <span class="opacity-50">{{item.deviceConnector}}</span>
                  </div>
                  <div class="ml-2">
                    <span v-if="item.time == null" class="opacity-50">{{$t('generalSettingMenu.Unknown')}}</span>
                    <span v-if="item.time <2 && item.time != null" class="opacity-50">{{$t('generalSettingMenu.justNow')}}</span>
                    <span v-if="item.time <60 && item.time >= 2" class="opacity-50">{{item.time}} {{$t('generalSettingMenu.minuteAgo')}}</span>
                    <span v-if="item.time >=60 && item.time <1440" class="opacity-50">{{parseInt(item.time/60)}} {{$t('generalSettingMenu.hoursAgo')}}</span>
                    <span v-if="item.time>=1440" class="opacity-50">{{parseInt(item.time/1440)}} {{$t('generalSettingMenu.daysAgo')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-col md:w-3/12 btnLogOut">
            <vs-button @click="confirmLogoutSubAcc(item)" color="danger" style="height: 37px;width: 137px;">{{$t('generalSettingMenu.btn6')}}</vs-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "LogOut",
  data() {
    return {
      usingPackage: {

      },
      activePopup:false,
      form:{
        image:null
      },
      checkTimeAgo:null,
      timeAgo:null,
      reduced_dasboard:false,
      showUpload:false,
      showUploadImage: false,
      acceptNotify: false,
      user: {
        gender: null,
        city: null,
        district: null,
        subDistrict: null,
        address: null,
        houseNumber: null,
        password: "",
        rePassword: "",
        activeStatus: 0
      },
      deviceInfo:[],
      infoDevice:{
      }
    }
  },
  methods:{
    confirmLogoutSubAcc(event){
      if(event){
        this.infoDevice = event;
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('generalSettingMenu.logOut'),
        text: `${this.$t('generalSettingMenu.textLogOut')}` +  ` ${event.deviceName}?`,
        accept: this.logoutSubAcc,
        acceptText: this.$t('managerKeyword.acceptText'),
        cancelText: this.$t('managerKeyword.cancelText')
      })
    },
    logoutSubAcc(){
      this.$vs.loading();
      this.$oauth.post('/user/logout-device',this.infoDevice)
      .then(()=>{
        if(this.infoDevice.isCurrentDevice == true){
          localStorage.removeItem("access_token");
          location.reload();
        }
        this.initScreen();
        this.$vs.loading.close();
        this.$vs.notify({
          text: `${this.$t('generalSettingMenu.logOutSuccess')}` +  ` ${this.infoDevice.deviceName}`,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }).catch((err) => {
        this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
      })
    },
    logout() {
      if (localStorage.getItem("deviceToken")) {
        this.$business.post('/notification/unsubscribe', {tokens: [localStorage.getItem("deviceToken")]}).then(() => {
          this.$vs.loading.close();
        }).catch(() => {
          this.$vs.loading.close();
        }).finally(()=>{
          localStorage.removeItem("access_token");
          location.reload();
        });
      } else {
        localStorage.removeItem("access_token");
        location.reload();
      }
    },
    initScreen(){
      this.$oauth.get('user/current').then((res) => {
        let user = res.data;
        this.user = Object.assign({}, this.user, user);
        this.deviceInfo = res.data.deviceInfo
        this.deviceInfo = this.deviceInfo.map(el=>{
          if (el.lastLogin) {
            let date = el.lastLogin;
            let today = new Date();
            let hours = (today.getTime() - date) / (60 * 1000);
            if (hours < 24) {
              el.lastLogin = parseInt(hours);
            } else if (24 <= hours < 720) {
              el.lastLogin = parseInt(hours)
            } else if (720 <= hours) {
              el.lastLogin = parseInt(hours)
            }
          }
          return {
            deviceName:el.deviceName,
            city:el.city,
            region:el.region,
            deviceConnector:el.deviceConnector,
            time:el.lastLogin,
            isCurrentDevice:el.isCurrentDevice,
            ipAddress: el.ipAddress
          }
        });
        if(user && user.allowNotify == 1){
          this.acceptNotify = true;
        }
      }).catch((err) => {
        this.initScreen();
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    }
  },
  created() {
    this.$oauth.get('user/current').then((res) => {
      let user = res.data;
      this.user = Object.assign({}, this.user, user);
      this.deviceInfo = res.data.deviceInfo;
      this.deviceInfo = this.deviceInfo.map(el=>{
        if (el.lastLogin) {
          let date = el.lastLogin;
          let today = new Date();
          let hours = (today.getTime() - date) / (60 * 1000);
          if (hours < 24) {
            this.checkTimeAgo = 0;
            el.lastLogin = parseInt(hours);
          } else if (24 <= hours < 720) {
            this.checkTimeAgo = 1;
            el.lastLogin = parseInt(hours)
          } else if (720 <= hours) {
            this.checkTimeAgo = 2;
            el.lastLogin = parseInt(hours)
          }
        }
        return {
          deviceName:el.deviceName,
          city:el.city,
          region:el.region,
          deviceConnector:el.deviceConnector,
          time:el.lastLogin,
          isCurrentDevice:el.isCurrentDevice,
          ipAddress: el.ipAddress
        }
      });
      if(user && user.allowNotify == 1){
        this.acceptNotify = true;
      }
    })
    this.userInfo = Object.assign({}, this.$store.state.userInformation, this.userInfo);
    this.$vs.loading();
    this.$business.post('/user-package/using-package').then((response) => {
      this.$vs.loading.close();
      this.usingPackage = response.data;
    }).catch(() => {
      this.showPopup = false;
      this.$vs.loading.close();
    });
    const mainLayoutType = localStorage.getItem('mainLayoutType');
    if(mainLayoutType == 'horizontal' || !mainLayoutType){
      this.reduced_dasboard == false;
    }
    else{
      this.reduced_dasboard =true
    }

    const data = localStorage.getItem('userInfo');
    const info = JSON.parse(data);
    if(info.img){
      this.userInfo.img = info.img;
    }
  }
}
</script>

<style scoped>
.icon-style{
  border-radius: 50%;
  width: 32px;
  background: #e5f5eb;
  height: 32px;
  display: flex;
  color: #44a572;
  justify-content: center;
  align-content: center;
}
.title_card{
  font-weight: bold;
  font-size: 28px;
  margin-left: -1rem;
}
.btnLogOut{
  display: flex;
  justify-content: flex-end;
}
</style>
